class BoogiSDK {
    constructor() {
        this.modal = null;
        this.iframeContainer = null;
    }

    async connectBank(token, mode = "api") {
        try {
            const finalUrl = `https://ob.boogi.io/connect?token=${token}&mode=${mode}`;
            this.openModal(finalUrl);
        } catch (error) {
            console.error('Error opening iframe:', error);
        }
    }

    async displayConnections(token, mode = "api") {
        try {
            const finalUrl = `https://ob.boogi.io/connections?token=${token}&mode=${mode}`;
            this.openModal(finalUrl);
        } catch (error) {
            console.error('Error opening iframe:', error);
        }
    }

    async displayOffers(token, mode = "api", containerId, options = {}) {
        try {
            const finalUrl = `https://ob.boogi.io/catalogue?token=${token}&mode=${mode}`;
            this.addIframe(finalUrl, containerId, options);
        } catch (error) {
            console.error('Error opening iframe:', error);
        }
    }

    addIframe(finalUrl, containerId, options = {}) {
        const defaultOptions = {
            width: '100%',
            height: '700px'
        };
        const finalOptions = { ...defaultOptions, ...options };

        // Locate the target container by ID
        const container = document.getElementById(containerId);
        if (!container) {
            console.error(`Container with ID "${containerId}" not found`);
            return;
        }

        // Clear the container before adding the iframe
        container.innerHTML = '';

        const iframe = document.createElement('iframe');
        iframe.src = finalUrl;
        iframe.style.width = finalOptions.width;
        iframe.style.height = finalOptions.height;
        
        // Append iframe to specified container
        container.appendChild(iframe);
    }

    openModal(finalUrl) {
        const defaultOptions = {
            width: '100%',
            height: '100%',
            border: 'none',
            closeButton: true,
            onClose: null,
            onLoad: null
        };

        const finalOptions = { ...defaultOptions };

        // Create modal structure
        this.modal = document.createElement('div');
        this.modal.className = 'modal';
        this.modal.style.display = 'block';

        const modalContent = document.createElement('div');
        modalContent.className = 'modal-content';
        modalContent.style.width = finalOptions.width;

        if (finalOptions.closeButton) {
            const closeModalBtn = document.createElement('span');
            closeModalBtn.className = 'close-btn';
            closeModalBtn.innerHTML = '&times;';
            closeModalBtn.onclick = () => this.closeModal(finalOptions.onClose);
            modalContent.appendChild(closeModalBtn);
        }

        this.iframeContainer = document.createElement('div');
        this.iframeContainer.id = 'iframe-container';

        const iframe = document.createElement('iframe');
        iframe.src = finalUrl;
        iframe.style.width = '100%';
        iframe.style.height = finalOptions.height;

        this.iframeContainer.appendChild(iframe);
        modalContent.appendChild(this.iframeContainer);

        // Add SVG watermark
        const watermark = document.createElement('div');
        watermark.className = 'watermark';
        watermark.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="88.038" height="34.95" viewBox="0 0 88.038 34.95">
                <path id="Path_89" data-name="Path 89" d="M11.179,7.669a7.165,7.165,0,0,0-5.2,1.889.221.221,0,0,1-.375-.149V1.18a.1.1,0,0,0-.1-.1H.1a.1.1,0,0,0-.1.1v21.18a5.1,5.1,0,0,0,5.095,5.095h6.085c4.9,0,8.936-4.31,8.936-9.893S16.078,7.669,11.179,7.669ZM10.058,22.134a4.274,4.274,0,0,1-4.449-4.572,4.274,4.274,0,0,1,4.449-4.572,4.274,4.274,0,0,1,4.449,4.572A4.274,4.274,0,0,1,10.058,22.134ZM30.4,27.456a9.893,9.893,0,1,0-9.908-9.893A9.81,9.81,0,0,0,30.4,27.456Zm0-5.471a4.2,4.2,0,0,1-4.3-4.422,4.3,4.3,0,1,1,8.6,0A4.2,4.2,0,0,1,30.4,21.984Zm20.191,5.471a9.893,9.893,0,1,0-9.908-9.893A9.81,9.81,0,0,0,50.588,27.456Zm0-5.471a4.2,4.2,0,0,1-4.3-4.422,4.3,4.3,0,1,1,8.6,0A4.2,4.2,0,0,1,50.588,21.984ZM75.629,8.411a.1.1,0,0,0-.1.1V9.526a.222.222,0,0,1-.381.144,6.715,6.715,0,0,0-5.077-2,9.269,9.269,0,0,0-9.2,9.518,9.269,9.269,0,0,0,9.2,9.518,6.714,6.714,0,0,0,5.077-2,.222.222,0,0,1,.381.144v1.145c0,2.661-1.608,4.01-4.225,4.01a4.265,4.265,0,0,1-4.212-2.269.1.1,0,0,0-.141-.039l-4.608,2.67a.1.1,0,0,0-.037.138c1.733,3.013,4.96,4.447,8.812,4.447,4.973,0,9.871-2.661,9.871-8.957V8.493a.1.1,0,0,0-.1-.1ZM71,21.535a4.237,4.237,0,0,1-4.524-4.347,4.528,4.528,0,0,1,9.048,0A4.237,4.237,0,0,1,71,21.535ZM84.435,6.745A3.4,3.4,0,0,0,87.8,3.373a3.365,3.365,0,0,0-6.73,0,3.4,3.4,0,0,0,3.365,3.373Zm-2,20.084a.1.1,0,0,0,.1.1h5.4a.1.1,0,0,0,.1-.1V8.3a.1.1,0,0,0-.107-.1l-5.4.29a.1.1,0,0,0-.1.1Z" fill="#64758b" opacity="0.52"/>
            </svg>
        `;
        modalContent.appendChild(watermark);

        this.modal.appendChild(modalContent);
        document.body.appendChild(this.modal);

        if (typeof finalOptions.onLoad === 'function') {
            iframe.onload = finalOptions.onLoad;
        }

        // Close modal when clicking outside the modal content
        window.onclick = (event) => {
            if (event.target === this.modal) {
                this.closeModal(finalOptions.onClose);
            }
        };
    }

    closeModal(onClose) {
        if (this.modal) {
            document.body.removeChild(this.modal);
            this.modal = null;
            this.iframeContainer = null;
            if (typeof onClose === 'function') {
                onClose();
            }
        }
    }
}
require('./style.css');
module.exports = BoogiSDK;
